import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/WEC-SIN33-JOB1/packages/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Leisure(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.157 1.986a1 1 0 10-1.966.365l.007.041c-1.95.538-3.628 1.549-4.82 2.844-1.385 1.506-2.148 3.45-1.775 5.458a1 1 0 001.166.801l.35-.065a1 1 0 00.708-.528c.176-.344.653-.742 1.38-.877.728-.135 1.316.065 1.605.323a1 1 0 00.85.238l.01-.002.027-.005.663-.123a1 1 0 00.708-.528c.082-.16.23-.332.437-.484l2.335 12.57a1 1 0 001.967-.365L15.473 9.08c.248.067.448.175.582.295a1 1 0 00.85.238l.671-.125.013-.002.018-.004a1 1 0 00.708-.527c.176-.345.653-.743 1.38-.878.728-.135 1.316.065 1.605.323a1 1 0 00.85.238l.35-.065a1 1 0 00.8-1.165c-.373-2.008-1.784-3.549-3.618-4.457-1.576-.78-3.505-1.121-5.517-.923l-.008-.041zM19.33 6.11c-.534.099-1.04.292-1.483.561a13.944 13.944 0 00-1.077-2.23 9.05 9.05 0 00-.249-.384 7.494 7.494 0 012.273.685c.704.348 1.28.792 1.71 1.305a4.478 4.478 0 00-1.174.063zm-5.2-1.758c-.277-.215-.457-.24-.582-.22l-.009.003-.008.001c-.125.025-.285.112-.467.414-.194.32-.354.795-.465 1.394a11.46 11.46 0 00-.168 1.812 4.373 4.373 0 011.655-.672 4.373 4.373 0 011.786.033c-.228-.559-.5-1.13-.808-1.63-.318-.52-.638-.906-.934-1.135zm-3.403.782A7.493 7.493 0 008.85 6.589c-.532.578-.91 1.2-1.126 1.833a4.478 4.478 0 012.703-.373c0-.791.055-1.658.204-2.467.028-.149.06-.299.095-.448zm-7.802 7.484a1 1 0 00-1.849.764c.18.435.348.916.534 1.447.062.18.127.365.195.556.26.734.559 1.527.933 2.268.525 1.04 1.257 2.083 2.352 2.71l-2.364.675a1 1 0 00.549 1.924l5.855-1.673 2.315 1.543a1 1 0 001.11-1.664l-1.416-.944c.245-.13.46-.261.647-.381l.307-.2v-.001h.001c.158-.104.264-.174.374-.232a1 1 0 00-.936-1.768c-.197.105-.43.257-.63.39l-.195.127c-.27.172-.556.34-.89.482-.647.274-1.548.48-2.885.278-1.04-.158-1.773-.91-2.409-2.168-.314-.622-.577-1.315-.833-2.035l-.178-.505c-.19-.545-.384-1.101-.587-1.593z",
    fill: props.color || "#222"
  }));
}
var MemoLeisure = React.memo(Leisure);
export default MemoLeisure;